import { Component, Input, forwardRef } from '@angular/core';
import { EoBaseFormControlComponent } from '../eo-base-form-control/eo-base-form-control.component';
import { EoPickListService } from './eo-pick-list.service';
import { STATUS } from '../../common/use-loading.model';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { combineLatest, map } from 'rxjs';
import { IPickList } from './picklist.model';
import { styleProperties } from '../../table/model/common-models/style.model';

@Component({
  selector: 'eo-pick-list',
  templateUrl: './eo-pick-list.component.html',
  styleUrl: './eo-pick-list.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoPickListComponent),
      multi: true,
    }
  ],
})
export class EoPickListComponent extends EoBaseFormControlComponent  {
  @Input() sourceProducts: string[] = [];
  @Input() targetProducts: string[] = [];
  @Input() targetHeader: string = 'Selected';
  @Input() sourceHeader: string = 'Available';
  @Input() dragdrop: boolean = true;
  @Input() responsive: boolean = true;
  @Input() sourceStyle: styleProperties = { height: '10rem' };
  @Input() targetStyle: styleProperties = { height: '10rem' };
  @Input() filterBy: string = 'name';
  @Input() optionValue: string = 'name';
  @Input() sourceFilterPlaceholder: string = 'Search by name';
  @Input() targetFilterPlaceholder: string = 'Search by name';
  @Input() sourceUrl: string = 'v1/source';
  @Input() targetUrl: string = 'v1/target';

  httpAvailable$ = this.picklistService.picklistproducts$;
  httpSelected$ = this.picklistService.picklistproductsTarget$;
  httpStatus$ = this.picklistService.status$;
  httpError$ = this.picklistService.error$;

  difference$ = combineLatest([this.httpAvailable$, this.httpSelected$]).pipe(
    map(([available, selected]) => this.getDifference(available, selected))
  );

  fetchData(): void {
    this.picklistService.getPickListSourceProducts(this.sourceUrl).subscribe();
    this.picklistService.getPickListTargetProducts(this.targetUrl).subscribe();

    // this.picklistService.getPickListSourceProductsMock().subscribe();
    // this.picklistService.getPickListTargetProductsMock().subscribe();
  }

  constructor(private picklistService: EoPickListService) {
    super();
  }

  override ngOnInit(): void {
    this.fetchData();
    this.subscriptions = [...this.subscriptions, this.onHttpStatusChange()];
  }

  onHttpStatusChange() {
    return this.httpStatus$.subscribe((status) => {
      switch (status) {
        case STATUS.loading:
          this.loading = true;
          break;
        default:
          this.loading = false;
      }
    });
  }

  getDifference(available: IPickList[], selected: IPickList[]): IPickList[] {
    const index = this.optionValue;
    const currentSelected = selected.map(item => item[index]);

    const difference = available.filter(item => !currentSelected.includes(item[index]));

    return difference;
  }
}
